import { handleActions } from "redux-actions";
import {
    WHITEBOARD_BULK_EXPORT_XLSX_PROCESSING,
    WHITEBOARD_BULK_EXPORT_XLSX_COMPLETED,
    WHITEBOARD_EXPORT_NOTIFICATIONS,
} from "constants/action-types";

interface IState {
    unseen: number;
    unread: number;
    exports: {
        createdOn: number;
        is_read: boolean;
        is_seen: boolean;
        error?: boolean;
        images?: boolean;
        files: string[];
        products: string[];
        id: string;
    }[];
}

const initialState: IState = {
    unseen: 0,
    unread: 0,
    exports: [],
};

export const exportNotifications = handleActions(
    {
        [WHITEBOARD_BULK_EXPORT_XLSX_PROCESSING]: (state: IState, { exportNotifications }: any): IState => {
            return {
                ...state,
                unseen: state.unseen + 1,
                unread: state.unread + 1,
                exports: [...state.exports, ...exportNotifications.exports],
            };
        },
        [WHITEBOARD_EXPORT_NOTIFICATIONS.UPDATE]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                exports: payload.exports,
            };
        },
        [WHITEBOARD_EXPORT_NOTIFICATIONS.STATUS]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                unseen: payload.unseen,
                unread: payload.unread,
            };
        },
        [WHITEBOARD_BULK_EXPORT_XLSX_COMPLETED]: (state: IState, { exportNotifications }: any): IState => {
            const exports = state.exports.map((item) =>
                item.id === exportNotifications.exports[0].id ? { ...item, ...exportNotifications.exports[0] } : item
            );
            return {
                ...state,
                exports,
            };
        },
    },

    initialState
);
